import React, { useState, useEffect } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import Footer from '../../composant_reutilisable/footer';
import useAuth from '../../composant_reutilisable/useAuth';
import { Link, useNavigate } from "react-router-dom";
import TableauDynamique from "../../composant_reutilisable/tableau";
import { FaCheck, FaEdit, FaPlus, FaQuestionCircle, FaSearch, FaTrash } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import { BsPerson } from "react-icons/bs";

const Liste_utilisateur = () => {
    useAuth();
    const utilisateur_id = localStorage.getItem("userId");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const navigate = useNavigate();

    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Utilisateurs";
        }
    }, [user_id]);

    // États
    const [userData, setUserData] = useState({});
    const [listeUtilisateur, setListeUtilisateur] = useState([]);

    // États pour la recherche et la pagination
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // État pour suivre l'utilisateur sélectionné
    const [utilisateurSelectionne, setUtilisateurSelectionne] = useState(null);


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    // Récupérer les données de l'utilisateur
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(process.env.REACT_APP_HOTE + `/api/recup-info-profil/${utilisateur_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [utilisateur_id]);


    // Récupérer la liste des utilisateurs
    const fetchUtilisateurs = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/api/liste-utilisateurs/");
            if (response.ok) {
                const data = await response.json();
                setListeUtilisateur(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des utilisateurs:", error);
        }
    };

    useEffect(() => {
        fetchUtilisateurs();
    }, []);

    const colonnesUtilisateurs = [
        //{ titre: "ID", cle: "id" },
        { titre: "Ref compte", cle: "ref_compte" },
        { titre: "Nom", cle: "nom" },
        { titre: "Prénoms", cle: "prenoms" },
        { titre: "Pseudo", cle: "pseudo" },
        { titre: "Email", cle: "email" },
        { titre: "Téléphone", cle: "telephone" },
        { titre: "Type compte", cle: "type_compte" },
        { titre: "Statut", cle: "statut_compte" },
        // { titre: "role", cle: "Rôle" },
    ];

    // Filtrer les utilisateurs selon le terme de recherche
    const utilisateursFiltres = listeUtilisateur.filter(user =>
        (user.nom || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.prenoms || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.ref_compte || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.telephone || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.pseudo || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.type_compte || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.email || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.statut_compte || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    const colonnesdropdown = [
        {
            label: "Activer/Désactiver",
            icon: <FaEdit color="orange" />,
            actionKey: "active",
        },
        {
            label: "Supprimer",
            icon: <FaTrash color="red" />,
            actionKey: "delete",
        },
    ];

    const handleAction = (utilisateurSelectionne, action) => {
        console.log("Utilisateur sélectionné :", utilisateurSelectionne);
        console.log("Action reçue :", action);
        if (!utilisateurSelectionne || !action) {
            console.error("Action invalide ou utilisateur non défini");
            return;
        }

        switch (action.actionKey) {
            case "active":
                handleActiverDesactiver(utilisateurSelectionne);
                break;
            case "delete":
                handleOpenModal(utilisateurSelectionne);
                break;
            default:
                console.log("Action inconnue :", action);
        }
    };

    // Pagination
    const totalItems = utilisateursFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const utilisateursAffiches = utilisateursFiltres.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionUtilisateur = (user) => {
        setUtilisateurSelectionne(user);
    };

    // Fonction d'activation ou de désactivation des utilisateurs
    const handleActiverDesactiver = async (utilisateurSelectionne) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/activer-utilisateur/${utilisateurSelectionne.id}/`, {
                method: "POST",

            });

            if (response.ok) {

                const data = await response.json(); // On récupère le retour du serveur
                console.log(`✅ Utilisateur ${utilisateurSelectionne.nom} ${data.action} avec succès depuis le serveur.`);
                // Actualisation de la liste complète des utilisateurs
                fetchUtilisateurs();

                // Affichage du message de confirmation
                showAlert(`Utilisateur ${utilisateurSelectionne.nom} ${utilisateurSelectionne.prenoms} ${data.action} avec succès`, "success");

                // Fermer le modal
                setShowModal(false);

                // Réinitialisation de la sélection
                setUtilisateurSelectionne(null);
            } else {
                console.error(`❌ Erreur lors de l'activation/désactivation de ${utilisateurSelectionne.nom}.`);
                showAlert(`Erreur lors de l'activation ou de la désactivation de l'utilisateur ${utilisateurSelectionne.nom}.`, "danger");
            }

        } catch (error) {
            console.error("❌ Erreur serveur :", error);
            showAlert("Erreur serveur lors de l'activation ou de la désactivation de l'utilisateur.", "danger");
        }
    };

    // // Fonction d'activation ou de désactivation des utilisateurs
    // const handlemdp = async () => {
    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_HOTE}/hasher-mots-passe/`, {
    //             method: "POST",

    //         });

    //         if (response.ok) {

    //             const data = await response.json(); // On récupère le retour du serveur
    //             console.log(`✅ mots de passe hasher.`);
    //             // Actualisation de la liste complète des utilisateurs
    //             fetchUtilisateurs();

    //             // Affichage du message de confirmation
    //             showAlert(`mots de passe hasher`, "success");


    //         } else {
    //             console.error(`❌ Erreur lors du hashage `);
    //             showAlert(`Erreur lors de du hashage`, "danger");
    //         }

    //     } catch (error) {
    //         console.error("❌ Erreur serveur :", error);
    //         showAlert("Erreur serveur lors de l'activation ou de la désactivation de l'utilisateur.", "danger");
    //     }
    // };


    // Fonction de suppression
    const handleSupprimer = async () => {
        if (!utilisateurSelectionne) {
            console.log("❗ Aucun utilisateur sélectionné pour la suppression.");
            return;
        }

        console.log(`📤 Tentative de suppression de l'utilisateur avec l'ID : ${utilisateurSelectionne.id}`);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-utilisateur/${utilisateurSelectionne.id}/${user_id}`, {
                method: "DELETE",
            });

            if (response.ok) {
                console.log(`✅ Utilisateur ${utilisateurSelectionne.nom} supprimé avec succès depuis le serveur.`);

                // Mise à jour de la liste des utilisateurs après suppression
                setListeUtilisateur(listeUtilisateur.filter(u => u.id !== utilisateurSelectionne.id));
                // Réinitialisation de la sélection
                setUtilisateurSelectionne(null);
                setShowModal(false);

                // Affichage du message de confirmation
                showAlert(`Utilisateur ${utilisateurSelectionne.nom} ${utilisateurSelectionne.prenoms} supprimé avec succès`, "success");

            } else {
                console.error(`❌ Erreur lors de la suppression de l'utilisateur ${utilisateurSelectionne.nom}.`);
                showAlert(`Erreur lors de la suppression de l'utilisateur ${utilisateurSelectionne.nom}.`, "danger");
            }
        } catch (error) {
            console.error("❌ Erreur réseau lors de la suppression :", error);
            showAlert("Une erreur s'est produite lors de la suppression. Veuillez réessayer.", "danger");
        } finally {
            setShowModal(false);
        }
    };


    const [showModal, setShowModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(""); // Stocke le rôle sélectionné

    const handleOpenModal = (utilisateurSelectionne) => {
        setUtilisateurSelectionne(utilisateurSelectionne);
        if (!utilisateurSelectionne) return;
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedRole(""); // Réinitialiser après fermeture
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <BsPerson size={25} className='mr-2' />Gestion des Utilisateurs
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'utilisateurs'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button>
                            </h2>
                            <small>Administration des utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        <Link to={`/Liste-utilisateur`}> Utilisateurs</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des utilisateurs</h5>
                                <div className="d-flex flex-column flex-md-row">
                                    {/* <button className="btn btn-success mr-2" onClick={handleOpenModal}>
                                        <FaPlus />Créer un compte
                                    </button> */}
                                    {/* <button
                                        onClick={handleOpenModal}
                                        disabled={!utilisateurSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${utilisateurSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaTrash /> Supprimer
                                    </button> */}
                                    {/* <button
                                        onClick={handleActiverDesactiver}
                                        disabled={!utilisateurSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${utilisateurSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaCheck /> Activer/Désactiver
                                    </button> */}
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <TableauDynamique
                                                colonnes={colonnesUtilisateurs}
                                                donnees={utilisateursFiltres}
                                                isLoading={isLoading}
                                                colonnesdropdown={colonnesdropdown}
                                                onAction={handleAction}
                                                messageAucun="Aucun utilisateur trouvé."
                                                // onSelectRow={handleSelectionUtilisateur}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>

                    {/* Modal de confirmation de suppression */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la Suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer le compte de <strong>{utilisateurSelectionne?.nom} {utilisateurSelectionne?.prenoms}</strong> ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                <strong>Annuler</strong>

                            </Button>
                            <Button variant="success" onClick={handleSupprimer}>
                                <strong>Supprimer</strong>

                            </Button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>
        </div>
    );
};

export default Liste_utilisateur;
